import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Gallery() {


    return (
        <div id="wrapper">

            {/* Header component */}
            <Header />

            <div className="no-bottom no-top" id="content">
                <div id="top"></div>

                <section id="profile_banner" aria-label="section" className="text-light" style={{ backgroundImage: 'url(https://f8n-production.imgix.net/worlds/po7tya6ba.jpg?auto=format%2Ccompress&q=70&cs=srgb&w=750&h=500&fit=crop&dpr=2&fnd_key=v1)' }}>
                </section>

                <section aria-label="section" className="d_coll no-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="d_profile" >
                                    <div className="profile_avatar" >
                                        <div className="d_profile_img">
                                            <img src="images/author/author-1.jpg" alt="" />
                                            {/*<i className="fa fa-check"></i>*/}
                                        </div>
                                        <div className="profile_name">
                                            <h1>
                                                Galleria Studio Gariboldi
                                                <div className="clearfix"></div>

                                            </h1>
                                        </div>

                                        {/*<div className="st--c-PJLV">
                                            <div className="st--c-eMHCPc dark-mode">
                                                <div className="st--c-PJLV st--c-PJLV-iketQnR-css">
                                                    <div className="st--c-cJzNYk st--c-cJzNYk-dpQLpG-clickable-true">
                                                        <div className="st--c-jpoJga"></div>
                                                        <div className="st--c-jCxxLK st--c-cbVHGe st--c-jCxxLK-kGICcE-size-0 st--c-jCxxLK-gpKjOp-size-1">
                                                            Creators
                                                        </div>
                                                        <div className="st--c-PJLV st--c-dhzjXW st--c-PJLV-iknqeEl-css">
                                                            <div className="st--c-jCxxLK st--c-gjdJOs st--c-jCxxLK-jkLkBP-size-3 st--c-jCxxLK-iqCzBn-weight-semibold st--c-jCxxLK-eMHCPc-color-strong st--c-jCxxLK-VGUHI-size-4 st--c-jCxxLK-bXcOWM-size-2">
                                                                86
                                                            </div>
                                                            <div className="st--c-PJLV st--c-PJLV-ivbRmY-css">
                                                                <div className="st--c-lbvDgV st--c-lbvDgV-XkTWe-size-1 st--c-lbvDgV-jhmweY-size-2">
                                                                    <div className="st--c-PJLV" aria-expanded="false">
                                                                        <a aria-label="Nate Hill" href="/@natehill">
                                                                            <div
                                                                                role="image"
                                                                                className="st--c-iQARZQ st--c-iQARZQ-bXfSeM-size-1 st--c-iQARZQ-rloUt-shape-circle st--c-iQARZQ-bYIUWo-size-2"
                                                                                style={{
                                                                                    backgroundImage:
                                                                                        'url("https://f8n-production.imgix.net/creators/profile/d16waohwz-natelogosmall-jpg-e4ay9b.jpg?auto=format,compress&q=50&cs=srgb&w=128&h=128&fit=crop&dpr=2&fnd_key=v1")',
                                                                                }}
                                                                            ></div>
                                                                        </a>
                                                                    </div>
                                                                    <div className="st--c-PJLV" aria-expanded="false">
                                                                        <a aria-label="Slava 3ngl" href="/@slava3ngl">
                                                                            <div
                                                                                role="image"
                                                                                className="st--c-iQARZQ st--c-iQARZQ-bXfSeM-size-1 st--c-iQARZQ-rloUt-shape-circle st--c-iQARZQ-bYIUWo-size-2"
                                                                                style={{
                                                                                    backgroundImage:
                                                                                        'url("https://f8n-production.imgix.net/creators/profile/w67sdbmqx.png?auto=format,compress&q=50&cs=srgb&w=128&h=128&fit=crop&dpr=2&fnd_key=v1")',
                                                                                }}
                                                                            ></div>
                                                                        </a>
                                                                    </div>
                                                                    <div className="st--c-PJLV" aria-expanded="false">
                                                                        <a aria-label="Kitasavi" href="/@kitasavi">
                                                                            <div
                                                                                role="image"
                                                                                className="st--c-iQARZQ st--c-iQARZQ-bXfSeM-size-1 st--c-iQARZQ-rloUt-shape-circle st--c-iQARZQ-bYIUWo-size-2"
                                                                                style={{
                                                                                    backgroundImage:
                                                                                        'url("https://f8n-production.imgix.net/creators/profile/evii3bj3i-kitasavi-pic-jpg-ukmyr4.jpg?auto=format,compress&q=50&cs=srgb&w=128&h=128&fit=crop&dpr=2&fnd_key=v1")',
                                                                                }}
                                                                            ></div>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="st--c-cJzNYk st--c-cJzNYk-dpQLpG-clickable-true">
                                                        <div className="st--c-jpoJga"></div>
                                                        <div className="st--c-jCxxLK st--c-cbVHGe st--c-jCxxLK-kGICcE-size-0 st--c-jCxxLK-gpKjOp-size-1">
                                                            Collectors
                                                        </div>
                                                        <div className="st--c-PJLV st--c-dhzjXW st--c-PJLV-iknqeEl-css">
                                                            <div className="st--c-jCxxLK st--c-gjdJOs st--c-jCxxLK-jkLkBP-size-3 st--c-jCxxLK-iqCzBn-weight-semibold st--c-jCxxLK-eMHCPc-color-strong st--c-jCxxLK-VGUHI-size-4 st--c-jCxxLK-bXcOWM-size-2">
                                                                129
                                                            </div>
                                                            <div className="st--c-PJLV st--c-PJLV-ivbRmY-css">
                                                                <div className="st--c-lbvDgV st--c-lbvDgV-XkTWe-size-1 st--c-lbvDgV-jhmweY-size-2">
                                                                    <div className="st--c-PJLV" aria-expanded="false">
                                                                        <a aria-label="FlyingBeagle" href="/@FlyingBeagle">
                                                                            <div
                                                                                role="image"
                                                                                className="st--c-iQARZQ st--c-iQARZQ-bXfSeM-size-1 st--c-iQARZQ-rloUt-shape-circle st--c-iQARZQ-bYIUWo-size-2"
                                                                                style={{
                                                                                    backgroundImage:
                                                                                        'url("https://f8n-production.imgix.net/creators/profile/hqzgwghtm.gif?auto=format,compress&q=50&cs=srgb&w=128&h=128&fit=crop&dpr=2&fnd_key=v1")',
                                                                                }}
                                                                            ></div>
                                                                        </a>
                                                                    </div>
                                                                    <div className="st--c-PJLV" aria-expanded="false">
                                                                        <a aria-label="skygolpe" href="/@skygolpe">
                                                                            <div
                                                                                role="image"
                                                                                className="st--c-iQARZQ st--c-iQARZQ-bXfSeM-size-1 st--c-iQARZQ-rloUt-shape-circle st--c-iQARZQ-bYIUWo-size-2"
                                                                                style={{
                                                                                    backgroundImage:
                                                                                        'url("https://f8n-production.imgix.net/creators/profile/le1c5wf49-senza-titolo-1-jpg-pzetbq.jpg?auto=format,compress&q=50&cs=srgb&w=128&h=128&fit=crop&dpr=2&fnd_key=v1")',
                                                                                }}
                                                                            ></div>
                                                                        </a>
                                                                    </div>
                                                                    <div className="st--c-PJLV" aria-expanded="false">
                                                                        <a aria-label="REUSS Collection" href="/@reusscollection">
                                                                            <div
                                                                                role="image"
                                                                                className="st--c-iQARZQ st--c-iQARZQ-bXfSeM-size-1 st--c-iQARZQ-rloUt-shape-circle st--c-iQARZQ-bYIUWo-size-2"
                                                                                style={{
                                                                                    backgroundImage:
                                                                                        'url("https://f8n-production.imgix.net/creators/profile/umb7xilou.jpg?auto=format,compress&q=50&cs=srgb&w=128&h=128&fit=crop&dpr=2&fnd_key=v1")',
                                                                                }}
                                                                            ></div>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="st--c-cJzNYk st--c-cJzNYk-dpQLpG-clickable-true">
                                                        <div className="st--c-jpoJga"></div>
                                                        <div className="st--c-jCxxLK st--c-cbVHGe st--c-jCxxLK-kGICcE-size-0 st--c-jCxxLK-gpKjOp-size-1">
                                                            Sales
                                                        </div>
                                                        <div className="st--c-jCxxLK st--c-gjdJOs st--c-jCxxLK-jkLkBP-size-3 st--c-jCxxLK-iqCzBn-weight-semibold st--c-jCxxLK-eMHCPc-color-strong st--c-jCxxLK-VGUHI-size-4 st--c-jCxxLK-bXcOWM-size-2 st--c-jCxxLK-idbzzBd-css">
                                                            6.72 ETH
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>*/}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 submenu" >
                                <div className="de_tab tab_simple">
                                    <ul className="de_nav pb30">
                                        <li className="active">
                                            <span>Home</span>
                                        </li>
                                        <li>
                                            <span>Exhibitions</span>
                                        </li>
                                        <li>
                                            <span>Collections</span>
                                        </li>
                                        <li>
                                            <span>Listings</span>
                                        </li>
                                        <li>
                                            <span>Sales</span>
                                        </li>
                                        <li>
                                            <span>Bio</span>
                                        </li>
                                    </ul>
                                    <div className="de_tab_content text-center">
                                        <div className="tab-1 bb">
                                            <div className="row">
                                                {/* nft item begin */}
                                                <div className='col-12 text-left'><h2>Listings</h2></div>
                                                <div class="col-md-3 col-lg-4 mb30 item">
                                                    <div class="nft_coll">
                                                        <div class="nft_wrap">
                                                            <a href="/item"><img src="images/items/big-6.jpg" class="lazy img-fluid" alt="" /></a>
                                                        </div>
                                                        <div className="nft__item_info">
                                                            <a href="/item">
                                                                <h3>Abstraction #256</h3>
                                                            </a>
                                                            <div className="nft__item_action">
                                                                <a href="/item">Buy now</a>
                                                            </div>
                                                            <div className="nft__item_price">
                                                                0.08 TON
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row text-left'>
                                                    <h2>Collections</h2>
                                                    <div className="d-item col-sm-6 col-md-4 col-lg-1-5">
                                                        <div class="owl-item active"><div class="nft_coll">
                                                            <div class="nft_wrap">
                                                                <a href="/collection"><img src="https://f8n-production-collection-assets.imgix.net/8453/0x1B592bD55ebA83719e224Bd54E1753c51D9fe834/1/nft.png?q=50&auto=format%2Ccompress&cs=srgb&h=640" class="lazy img-fluid" alt="" /></a>
                                                            </div>
                                                            <div class="nft_coll_pp">
                                                                <a href="/collection"><img class="lazy pp-coll" src="images/author/author-11.jpg" alt="" /></a>
                                                                <i class="fa fa-check"></i>
                                                            </div>
                                                            <div class="nft_coll_info">
                                                                <a href="/collection"><h3>Gilding Faces</h3></a>
                                                                <span>@NFTtalks</span>
                                                            </div>
                                                        </div></div>
                                                    </div>
                                                </div>


                                                <div className='col-12 text-left'><h2>Sold NFTs</h2></div>


                                            </div>

                                            <a href="#" className='btn-list'>View all listings</a>
                                        </div>

                                        <div className="tab-2" >
                                            <div className="row">
                                               
                                            </div>
                                        </div>

                                        <div className="tab-3">
                                            <div className="row">
                                                <div className="d-item col-sm-6 col-md-4 col-lg-1-5">
                                                    <div class="owl-item active"><div class="nft_coll">
                                                        <div class="nft_wrap">
                                                            <a href="/collection"><img src="https://f8n-production-collection-assets.imgix.net/8453/0x1B592bD55ebA83719e224Bd54E1753c51D9fe834/1/nft.png?q=50&auto=format%2Ccompress&cs=srgb&h=640" class="lazy img-fluid" alt="" /></a>
                                                        </div>
                                                        <div class="nft_coll_pp">
                                                            <a href="/collection"><img class="lazy pp-coll" src="images/author/author-11.jpg" alt="" /></a>
                                                            <i class="fa fa-check"></i>
                                                        </div>
                                                        <div class="nft_coll_info">
                                                            <a href="/collection"><h3>Gilding Faces</h3></a>
                                                            <span>@NFTtalks</span>
                                                        </div>
                                                    </div>
                                                </div>
                                             </div>
                                        </div>
                                        </div>
                                        <div className="tab-4">
                                            <div className="row">
                                                 <div class="col-md-3 col-lg-4 mb30 item">
                                                    <div class="nft_coll">
                                                        <div class="nft_wrap">
                                                            <a href="/item"><img src="images/items/big-6.jpg" class="lazy img-fluid" alt="" /></a>
                                                        </div>
                                                        <div className="nft__item_info">
                                                            <a href="/item">
                                                                <h3>Abstraction #256</h3>
                                                            </a>
                                                            <div className="nft__item_action">
                                                                <a href="/item">Buy now</a>
                                                            </div>
                                                            <div className="nft__item_price">
                                                                0.08 TON
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* Footer */}
            <Footer />

        </div>
    );
}

export default Gallery;